import { styled, useTheme } from '@mui/system'
const H1 = styled('h1')(({ theme }) => ({
    fontSize: '1.5rem',
    fontWeight: '500',
    marginBottom: '16px',
    textTransform: 'capitalize',
    color: theme.palette.text.primary,
}))
const SectionTitle = ({ children }) => {
    

    return (
        
        <H1>{children || null}</H1>
                
    )
}

export default SectionTitle